import { ModelResource } from './resource';
import { UserInvite } from '../models';

export interface ValidateUserInviteResponse {
  email: string;
  organization_name: string;
  requires_password: boolean;
}

export interface PasswordResetValidateResponse {
  email: string;
  organization_name: string;
}

export class UserInvites extends ModelResource<UserInvite> {
  model = UserInvite;

  resourcePath = 'v1/user-invites';

  async getUserInvites(): Promise<UserInvite> {
    return this.api.get(this.path(), {}).then((response) => {
      return UserInvite.fromJson(response.data);
    });
  }

  async createInvites(data: {
    invitations: { email: string; is_admin?: boolean }[];
  }): Promise<UserInvite[]> {
    return this.api.post(this.path(), { data }).then((response) => {
      return response.data.map((rawInvite) => UserInvite.fromJson(rawInvite)) as UserInvite[];
    });
  }

  async resend(invite: UserInvite): Promise<UserInvite> {
    return this.api.post(this.path(invite.email, 'resend')).then((response) => {
      invite.updateFromJson(response.data);
      return invite;
    });
  }

  async validateInviteToken(token: string): Promise<ValidateUserInviteResponse> {
    return this.api.post(this.path('token', 'validate'), { data: { token } }).then((response) => {
      return response.data;
    });
  }
}
